import type { SearchTourStep } from './searchTourSteps';

export const API_TOUR_STEPS: SearchTourStep[] = [
  {
    id: 'api-key',
    title: '1) Copy API key',
    body: 'Copy your API key from the header (only needed if you need to authorize protected endpoints).',
    selector: 'button[aria-label="Copy API key"]',
  },
  {
    id: 'authorize',
    title: '2) Authorize',
    body: 'Click “Authorize” to mark the API key as ready for the console.',
    selector: '.api-console-authorize-btn',
    prepare: ['api-authorize'],
  },
  {
    id: 'load-examples',
    title: '3) Load examples',
    body: 'Use “Load examples” to automatically fill request parameters.',
    selector: '.api-console-fill-examples',
    prepare: ['api-load-examples'],
  },
  {
    id: 'try-it-out',
    title: '4) Try it out',
    body: 'Click “Try it out” to execute the selected endpoint request.',
    selector: '.api-console-send',
    prepare: ['api-try-it-out'],
  },
  {
    id: 'response',
    title: '5) Read the response',
    body: 'Inspect the JSON response body (or switch to Headers).',
    selector: '.api-console-response-body',
  },
];

